import { type FeedItem, NetworkStatus } from '@knocklabs/client'
import { useNotificationStore } from '@knocklabs/react-core'
import { type InboxItem, isInboxItem } from '@seen/core/models/inbox'
import { useCallback, useMemo } from 'react'
import { useKnockFeedClient } from '#src/hooks/useKnockFeedClient.ts'

export const KNOCK_PAGE_SIZE = 50

export interface NotificationItem extends FeedItem {
  data: InboxItem
}

interface UseNotificationItemsResult {
  items: NotificationItem[]
  loading: boolean
  hasMore: boolean
  isLoadingMore: boolean
  fetchNextPage: () => void
}

export function useNotificationItems(): UseNotificationItemsResult {
  const feedClient = useKnockFeedClient()

  const {
    items: feedItems,
    loading,
    pageInfo,
    networkStatus,
  } = useNotificationStore(feedClient)
  const items = useMemo(
    () =>
      feedItems
        .filter((feedItem) => isInboxItem(feedItem.data))
        .map((feedItem) => ({
          ...feedItem,
          data: feedItem.data as InboxItem,
        })),
    [feedItems]
  )

  const hasMore = pageInfo.after !== null
  const isLoadingMore = networkStatus === NetworkStatus.fetchMore

  const fetchNextPage = useCallback(() => {
    void feedClient.fetchNextPage()
  }, [feedClient])

  return { items, loading, hasMore, isLoadingMore, fetchNextPage }
}
